export enum LogInError {
    AuthenticationError = "Bad Credentials",
    AccountLocked = "Account locked because of too many attempts",
    AccountBarred = "Can't sign in because this account is currently disabled!",
    PasswordExpired ="Temporary password expired!",
    ContractExpired = "Can not log in due to partner contract termination"
}